






















































































































import { Component, Mixins } from 'vue-property-decorator';

import OfflineMixin from '@/mixins/OfflineMixin';

import Logo from '@/components/Logo/Logo.vue';
import LogOutDialog from '@/components/LogOutDialog/LogOutDialog.vue';

@Component({
  components: {
    Logo,
    LogOutDialog,
  },
  name: 'AppNav',
})
export default class AppNav extends Mixins(OfflineMixin) {
  toggleTheme() {
    const storageKey = 'iLabs.appStore.darkMode.enabled';
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark;

    try {
      window.localStorage.setItem(storageKey, JSON.stringify(this.$vuetify.theme.dark));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
}
